"use client";
import { is_function } from "@core/helpers/function";
import {
  add_blog_to_favorites_mutation,
  get_favorite_blogs_query,
} from "@core/services/blogs";
import { useCallback, useEffect, useState } from "react";

const DEFAULT_FAVORITE_BLOGS_LIMIT = 100;

const useBlog = (data, favorite_blogs_limit) => {
  const [is_favorite, set_is_favorite] = useState(data?.is_favorite);
  const [favorite_blogs_loading, set_favorite_blogs_loading] = useState(true);
  const [add_to_favorites_loading, set_add_to_favorites_loading] =
    useState(false);
  const [favorite_blogs, set_favorite_blogs] = useState([]);
  const [favorite_blogs_pagination, set_favorite_blogs_pagination] = useState({
    page: 1,
    limit: favorite_blogs_limit || DEFAULT_FAVORITE_BLOGS_LIMIT,
    pages: 1,
    total: 0,
  });

  useEffect(() => {
    if (data?.is_favorite !== is_favorite) {
      set_is_favorite(data?.is_favorite);
    }
  }, []);

  const add_to_favorites_handler = useCallback(
    async (e, args = {}) => {
      e?.preventDefault();
      const { success_callback, error_callback } = args;
      set_add_to_favorites_loading(true);
      const result = await add_blog_to_favorites_mutation({
        blog_id: data?.id,
        is_favorite: !is_favorite,
      });
      if (result?.status) {
        set_is_favorite((prev) => !prev);
        if (is_function(success_callback)) {
          success_callback({ ...result?.data, is_favorite: !is_favorite });
        }
      } else {
        if (is_function(error_callback)) {
          error_callback(result);
        }
      }
      set_add_to_favorites_loading(false);
    },
    [is_favorite]
  );

  /**
   * مقاله‌های لایک‌شده‌ی کاربر.
   *
   * صفحه و تعداد و ماکاپ کارت اختیاری‌اند تا صفحه‌ی علاقه‌مندی‌ها بتواند
   * صفحه‌بندی سرور را داشته باشد و هر سایت هم فیلدهای مورد نیاز کارت خودش را
   * بخواهد؛ بدون آرگومان همان رفتار قبلی (یک صفحه‌ی صد تایی) را می‌دهد.
   */
  const get_favorite_blogs = useCallback(
    async (args = {}) => {
      set_favorite_blogs_loading(true);

      const page = args?.page || 1;
      const limit =
        args?.limit || favorite_blogs_limit || DEFAULT_FAVORITE_BLOGS_LIMIT;

      const result = await get_favorite_blogs_query(
        { page, limit },
        { blog_card_mockup: args?.blog_card_mockup }
      );

      if (result?.status) {
        set_favorite_blogs(result?.data?.data);
        set_favorite_blogs_pagination((prev) => ({
          ...prev,
          page,
          limit,
          pages: result?.data?.paginate?.pages || 1,
          total: result?.data?.paginate?.total || 0,
        }));
      }
      set_favorite_blogs_loading(false);
    },
    [favorite_blogs_limit]
  );

  return {
    is_favorite,
    set_is_favorite,
    add_to_favorites_handler,
    add_to_favorites_loading,
    get_favorite_blogs,
    favorite_blogs,
    set_favorite_blogs,
    favorite_blogs_loading,
    favorite_blogs_pagination,
    set_favorite_blogs_pagination,
  };
};

export default useBlog;
